import { TFunction } from "i18next";
import { z } from "zod";

export const getDL38299FormSchema = (t: TFunction) =>
  z.object({
    imea: z.boolean().default(false),

    inta1: z.boolean().default(false),
    intb1: z.boolean().default(false),
    intc1: z.boolean().default(false),
    intd1: z.boolean().default(false),
    inte1: z.boolean().default(false),
    intf1: z.boolean().default(false),
    intg1: z.boolean().default(false),
    inth: z.boolean().default(false),
    inti: z.boolean().default(false),
    intj: z.boolean().default(false),
    intl: z.boolean().default(false),
    intm: z.boolean().default(false),
    intn: z.boolean().default(false),
    into: z.boolean().default(false),
    intp: z.boolean().default(false),
    intq: z.boolean().default(false),

    inta2: z.boolean().default(false),
    intb2: z.boolean().default(false),
    intc2: z.boolean().default(false),
    intd2: z.boolean().default(false),
    inte2: z.boolean().default(false),
    intf2: z.boolean().default(false),
    intg2: z.boolean().default(false),

    alra1: z.boolean().default(false),
    alrb1: z.boolean().default(false),
    alrc1: z.boolean().default(false),
    alrd1: z.boolean().default(false),
    alre1: z.boolean().default(false),
    alrf: z.boolean().default(false),
    alrg: z.boolean().default(false),
    alrh: z.boolean().default(false),
    alri: z.boolean().default(false),
    alrj: z.boolean().default(false),
    alrl: z.boolean().default(false),

    alra2: z.boolean().default(false),
    alrb2: z.boolean().default(false),
    alrc2: z.boolean().default(false),
    alrd2: z.boolean().default(false),
    alre2: z.boolean().default(false),
  });

export type DL38299Form = z.infer<
  ReturnType<typeof getDL38299FormSchema>
>;
